import React, { Component } from 'react'
import ContentAdd from 'material-ui/svg-icons/content/add'
import Layout from '../../components/Layout'
import EditModal from './EditModal'
import ListTable from './ListTable'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import { medicationsClassificationActions, searchTableActions } from '../../actions'
import Typography from '@material-ui/core/Typography'
import CrudHeader from '../../components/CrudHeader'
import { crudListStyle } from '../../styles'
import { Button } from '@material-ui/core'
import UserToolbar from '../../components/UserToolbar'

class MedicationClassification extends Component {
  state = {
    modalOpen: false
  }

  componentWillUnmount() {
    const { resetState } = this.props
    resetState()
  }

  render() {
    const {
      modalOpen,
      openModal,
      closeModal,
      newMedicationClassification,
      classes,
      token
    } = this.props
    return (
      <Layout toolBarRight={UserToolbar}>
        <CrudHeader
          title={'Classificação de Medicamentos'}
          classes={classes}
          newResource={newMedicationClassification}
          openModal={openModal}
          closeModal={closeModal}
          token={token}
          functionality={'classificacoes_medicamentos'}
        />

        <EditModal open={modalOpen} onClose={closeModal} />

        <ListTable />
      </Layout>
    )
  }
}

const mapStateToProps = state => {
  return { modalOpen: state.medicationClassification.modalOpen, token: state.auth.token }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(medicationsClassificationActions.openModal())
    },
    closeModal: () => {
      dispatch(medicationsClassificationActions.closeModal())
    },
    newMedicationClassification: medicationClassification => {
      dispatch(
        medicationsClassificationActions.newFormMedicationClassification(medicationClassification)
      )
    },
    resetState: () => {
      dispatch(medicationsClassificationActions.resetState())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(crudListStyle)(MedicationClassification))



// WEBPACK FOOTER //
// ./src/containers/MedicationClassification/index.js